import { fmtAUD } from '@/shared/utils/formatCurrency';

export function buildLeafTrendInsights(allTxns, selMonth, selYear, incomeList) {
  const txns = (allTxns || []).filter(t => t && t.date && t.category && !incomeList.includes(t.category));

  const byMonthCat = {};
  for (const t of txns) {
    const d = new Date(t.date);
    const key = d.getUTCFullYear() + '-' + String(d.getUTCMonth() + 1).padStart(2, '0');
    const cat = t.category;
    if (!byMonthCat[key]) byMonthCat[key] = {};
    byMonthCat[key][cat] = (byMonthCat[key][cat] || 0) + (Number(t.amount) || 0);
  }

  const curKey = selYear + '-' + String(selMonth + 1).padStart(2, '0');
  const curBycat = byMonthCat[curKey] || {};

  const priorKeys = [];
  for (let i = 1; i <= 3; i++) {
    let m = selMonth - i;
    let y = selYear;
    if (m < 0) { m += 12; y -= 1; }
    priorKeys.push(y + '-' + String(m + 1).padStart(2, '0'));
  }

  const allCats = new Set([
    ...Object.keys(curBycat),
    ...priorKeys.flatMap(k => Object.keys(byMonthCat[k] || {})),
  ]);

  const MIN_AVG = 30;
  const MIN_PCT = 25;

  const candidates = [];
  for (const cat of allCats) {
    const priorAmounts = priorKeys
      .map(k => (byMonthCat[k] || {})[cat] || 0)
      .filter(v => v > 0);

    if (priorAmounts.length < 2) continue;

    const avg = priorAmounts.reduce((s, v) => s + v, 0) / priorAmounts.length;
    if (avg < MIN_AVG) continue;

    const current = curBycat[cat] || 0;
    if (current === 0) continue;

    const pctChange = ((current - avg) / avg) * 100;
    if (Math.abs(pctChange) < MIN_PCT) continue;

    candidates.push({ cat, avg, current, pctChange });
  }

  candidates.sort((a, b) => Math.abs(b.pctChange) - Math.abs(a.pctChange));
  const top2 = candidates.slice(0, 2);

  return top2.map(({ cat, avg, current, pctChange }) => {
    const up = pctChange > 0;
    return {
      icon: up ? '📈' : '📉',
      color: up ? '#ef4444' : '#16a34a',
      text:
        String(cat) + ' is ' + (up ? 'up' : 'down') + ' ' +
        Math.abs(pctChange).toFixed(0) + '% vs your 3-month average ($' +
        fmtAUD(avg) + '/mo avg, $' + fmtAUD(current) + ' this month)',
    };
  });
}
